import * as React from 'react';
import { Input, Checkbox } from 'antd';
import { FormItem } from '../../../../components/Form';
import TextArea from 'antd/lib/input/TextArea';
import PriceInput from '../../../../components/Others/PriceInput';
import PricesByWeight from './PricesByWeight';
import Insurance from './Insurance';

export interface IGeneralSettingsColProps {
  currency: GQL.ICurrency;
  deliveryMethod: GQL.IDeliveryMethod;
  currentLanguage: string;
  onChange: Function;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps> {

  public render() {
    const { currency, deliveryMethod, currentLanguage } = this.props;

    return (
      <div>
        <FormItem label={'Internal name'} required={true}>
          <Input
            name={'title'}
            autoFocus={true}
            placeholder="Internal title. For example &quot;Ceska posta - balik do ruky&quot;"
            addonBefore={'Internal'}
            defaultValue={deliveryMethod.title}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Title'} required={true}>
          <Input
            key={currentLanguage}
            name={'name'}
            addonBefore={currentLanguage}
            defaultValue={(deliveryMethod.name || {})[currentLanguage]}
            required={true}
            onChange={e => this.props.onChange(e, currentLanguage)}
          />
        </FormItem>
        <FormItem label={'Code'}>
          <Input
            name={'code'}
            defaultValue={deliveryMethod.code}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Description'}>
          <TextArea
            key={currentLanguage}
            name={'description'}
            defaultValue={(deliveryMethod.description || {})[currentLanguage]}
            onChange={e => this.props.onChange(e, currentLanguage)}
          />
        </FormItem>

        <FormItem>
          <Checkbox
            name={'unknownPrice'}
            checked={deliveryMethod.unknownPrice === true}
            onChange={e => this.props.onChange(e)}
          >
            Unknown prices
          </Checkbox>
        </FormItem>

        {deliveryMethod.unknownPrice === true &&
          <FormItem label={'Unknown prices label'} required={true}>
            <Input
              key={currentLanguage}
              name={'unknownPriceLabel'}
              addonBefore={currentLanguage}
              defaultValue={(deliveryMethod.unknownPriceLabel || {})[currentLanguage]}
              onChange={e => this.props.onChange(e, currentLanguage)}
            />
          </FormItem>}

        {deliveryMethod.unknownPrice !== true &&
          <>
            <FormItem>
              <Checkbox
                name={'pricesByWeight'}
                checked={deliveryMethod.pricesByWeight !== null && deliveryMethod.pricesByWeight !== undefined ? deliveryMethod.pricesByWeight : false}
                onChange={e => this.props.onChange(e)}
              >
                Define prices by weight
              </Checkbox>
            </FormItem>

            {deliveryMethod.pricesByWeight !== true &&
              <FormItem
                label={'Price (vat excl.)'}
              >
                <PriceInput
                  name={'prices'}
                  prices={(deliveryMethod.prices || []) as any}
                  mode={'priceWithout'}
                  onChange={this.props.onChange}
                />
              </FormItem>}

            {deliveryMethod.pricesByWeight === true &&
              <PricesByWeight
                name={'prices'}
                deliveryMethod={deliveryMethod}
                onChange={this.props.onChange}
              />}
          </>}

        <FormItem
          label={'Average delivery time in days'}
        >
          <Input
            name={'days'}
            type={'number'}
            defaultValue={(deliveryMethod.deliveryTimeDays || '').toString()}
            onChange={e => this.props.onChange(e)}
            addonAfter={'DAYS'}
          />
        </FormItem>
        <FormItem label={'Priority'}>
          <Input
            name={'priority'}
            type={'number'}
            defaultValue={deliveryMethod.priority
              ? deliveryMethod.priority.toString()
              : undefined}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        {/* <FormItem
          label={'Delivery method type'}
          extra={'Required in export for price servers (heureka.cz, zbozi.cz)'}
        >
          <Select
            style={{ width: '100%' }}
            onChange={e => this.props.onChange(e)}
            placeholder="Delivery method type"
            defaultValue={deliveryMethod.type || ''}
          >
            {Object.keys(types).map((type: any) => (
              <Select.Option key={type} value={type}>
                {types[type]}
              </Select.Option>
            ))}
          </Select>
        </FormItem> */}
        <FormItem>
          <Checkbox
            name={'active'}
            checked={deliveryMethod.active !== null && deliveryMethod.active !== undefined ? deliveryMethod.active : true}
            onChange={e => this.props.onChange(e)}
          >
            Active
          </Checkbox>
        </FormItem>
        <Insurance
          deliveryMethod={deliveryMethod}
          currency={currency}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/General.tsx